import React, { useMemo } from "react";

import { MainNavigationInfo, OnlineLink } from "components";

type NavigationInfoHeaderProps = {
	data: { [key: string]: any };
	isLoading: boolean;
	contentMapper: any;
};

const NavigationInfoHeader = ({
	data,
	contentMapper,
	isLoading,
}: NavigationInfoHeaderProps) => {
	const navData = useMemo(
		() => ({
			mid: (
				<OnlineLink
					onClick={e => e.stopPropagation()}
					to={`/merchant/list/info/${data?.merchantId}/general`}
					target="_blank"
				>
					{data?.mid}
				</OnlineLink>
			),
			dbaName: data?.dbaName,
			merchant: { priorityType: data?.priorityType },
			reviewType: data?.reviewType,
		}),
		[
			data?.dbaName,
			data?.merchantId,
			data?.mid,
			data?.priorityType,
			data?.reviewType,
		],
	);

	return (
		<MainNavigationInfo
			content={contentMapper(navData)}
			loading={isLoading}
			className="mt-0"
		/>
	);
};

export default NavigationInfoHeader;
